"use client";
import { AppColors } from "@/assets/colors";
import { pxToRem } from "@/util";
import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  carouselContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position:'relative',
    // borderRadius:pxToRem(12),
  },
  carouselItem: {
    //borderRadius:pxToRem(12),// Debugging border
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%", // Full height
    flex: 1,
  },
  customDots: {
    "& .swiper-pagination-bullet": {
      backgroundColor: AppColors.neutral["75"], // Inactive dot
      width: pxToRem(16),
      height: pxToRem(16),
      borderRadius: "50%",
      opacity: 1,
      transition: "all 0.3s ease",
    },
    "& .swiper-pagination-bullet-active": {
      backgroundColor: AppColors.primary["300"], // Active dot
      border: `2px solid ${AppColors.primary["300"]}`,
      transform: "scale(1.2)", // Slightly enlarge the active dot
    },
  },
}));

type Props = {
  children: ReactNode[]|ReactNode;
  autoPlaySpeed?: number;
  isPagination?:boolean
};

export const FeaturedCarousel: React.FC<Props> = ({
  children,
  autoPlaySpeed = 3000,
  isPagination = true,
}) => {
  const { classes } = useStyles();

  return (
    <Swiper
       modules={[...(isPagination ? [Pagination] : []), Autoplay]}
      autoplay={{ delay: autoPlaySpeed }}
      pagination={{ clickable: true }}
      loop={true}
      className={`${classes.carouselContainer} ${classes.customDots}`}
    >
    {
      Array.isArray(children)?
      React.Children.toArray(children).map((child, index) => (
        <SwiperSlide key={index}>
          <Box className={classes.carouselItem}>{child}</Box>
        </SwiperSlide>
      )):
      <SwiperSlide >
          <Box className={classes.carouselItem}>{children}</Box>
        </SwiperSlide>
    }
      
    </Swiper>
  );
};
